import React, { useEffect, useState } from "react";
import axios from "axios";

const ServiceForm = () => {
  const [services, setServices] = useState([]); // State to store services
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    contactPerson: "",
    email: "",
    phone: "",
    serviceType: {}, // Dynamically populated serviceType
    specificNeeds: "",
    projectDuration: "",
    budgetRange: "",
    preferredStartDate: "",
    additionalNotes: "",
  });

  useEffect(() => {
    // Fetch services data
    const fetchServices = async () => {
      try {
        const response = await axios.get("https://mirai-server.vercel.app/service-main");
        setServices(response.data); // Update state with fetched data

        // Dynamically set serviceType based on fetched services
        const initialServiceType = response.data.reduce((acc, service) => {
          acc[service.service] = false; // Initialize each serviceType to false
          return acc;
        }, {});

        setFormData((prevData) => ({
          ...prevData,
          serviceType: initialServiceType, // Set dynamic serviceType
        }));

        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error("Error fetching services:", error);
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        serviceType: {
          ...prevData.serviceType,
          [name]: checked, // Update the serviceType field dynamically based on checkbox name
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value, // Update non-checkbox fields
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const submissionData = {
      ...formData,
    };
  
    try {
      const response = await axios.post(
        "https://mirai-server.vercel.app/upload-service-client",
        submissionData
      );
      alert(response.data.message || "Quotation request successfully!");
  
      // Reset the form state
      const resetServiceType = Object.keys(formData.serviceType).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
  
      setFormData({
        fullName: "",
        companyName: "",
        contactPerson: "",
        email: "",
        phone: "",
        serviceType: resetServiceType, // Reset all serviceType checkboxes
        specificNeeds: "",
        projectDuration: "",
        budgetRange: "",
        preferredStartDate: "",
        additionalNotes: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error.response?.data || error.message);
      alert("Failed to submit the form. Please try again.");
    }
  };
  

  // Render loading spinner if the services are still being fetched
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <h1 className="lg:text-4xl sm:text-2xl font-semibold font-jost customBlue lg:my-10 sm:my-5">
        Quotation Request Form
      </h1>
      <h2 className="lg:text-2xl sm:text-lg  font-jost customBlue lg:mb-5 sm:mb-2">
        Client Information
      </h2>
      <div className="flex lg:flex-row sm:flex-col lg:gap-20 sm:gap-5 w-full">
        <div className="w-full">
          <div class="relative z-0 w-full mb-5 group">
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              id="fullName"
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=""
            />
            <label
              for="fullName"
              name="fullName"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Full Name:
            </label>
          </div>

          <div class="relative z-0 w-full mb-5 group">
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              id="companyName"
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=""
            />
            <label
              for="companyName"
              name="companyName"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Company Name:
            </label>
          </div>

          <div class="relative z-0 w-full mb-5 group">
            <input
              type="text"
              name="contactPerson"
              value={formData.contactPerson}
              onChange={handleChange}
              id="contactPerson"
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=""
            />
            <label
              for="contactPerson"
              name="contactPerson"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Contact Person:
            </label>
          </div>
          <div class="relative z-0 w-full mb-5 group">
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
            />
            <label
              for="email"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Email Address:
            </label>
          </div>

          <div class="relative z-0 w-full mb-5 group">
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              //   pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
              id="phone"
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
              required
            />
            <label
              for="phone"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Phone number (+880-16299-64630)
            </label>
          </div>

          <div>
            <h2 className="peer-focus:font-medium mt-10 mb-4 lg:text-2xl sm:text-xl  font-jost text-gray-500">
              Consultancy Services Required
            </h2>

            {services.map((service, index) => (
              <div
                key={index}
                className="flex flex-row items-center sm:justify-between gap-2 mb-3"
              >
                <label className="lg:text-lg sm:text-sm font-jost text-gray-500">
                  {service.service}
                </label>
                <input
                  type="checkbox"
                  name={service.service} // Service name is used for the checkbox name
                  checked={formData.serviceType[service.service] || false} // Bind checkbox state dynamically
                  onChange={handleChange} // Handle checkbox change
                />
              </div>
            ))}

            {/* <div className="flex flex-row items-center gap-2">
            <label className="text-lg font-jost text-gray-500">Tax Planning & Consulting:</label>
            <input
              type="checkbox"
              name="tax"
              id="tax"
              placeholder=""
              checked={formData.serviceType.tax}
              onChange={handleChange}
            />
          </div> */}
            <div class="relative z-0 w-full mb-5 group">
              <input
                type="text"
                name="other"
                id="other"
                class="block py-2.5 px-0 w-full lg:text-xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=""
                value={formData.serviceType.other}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    serviceType: {
                      ...prevData.serviceType,
                      other: e.target.value,
                    },
                  }))
                }
              />
              <label
                for="other"
                name="other"
                class="peer-focus:font-medium absolute lg:text-lg sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Other:
              </label>
            </div>
          </div>
          {/* <div class="relative z-0 w-full mb-5 group">
            <input
              type="text"
              name="budgetRange"
              value={formData.budgetRange}
              id="budgetRange"
              onChange={handleChange}
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=""
            />
            <label
              for="budgetRange"
              name="budgetRange"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Budget Range:
            </label>
          </div> */}
        </div>

        <div className="w-full">
          <div className="flex lg:flex-row sm:flex-col justify-between gap-4 lg:mb-5 ">
            <div class="relative z-0 lg:w-[45%] sm:w-full lg:mb-5 group">
              <input
                type="text"
                name="projectDuration"
                value={formData.projectDuration}
                id="projectDuration"
                placeholder=""
                onChange={handleChange}
                class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              />
              <label
                for="projectDuration"
                name="projectDuration"
                class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:customBlue peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Estimated Project Duration:
              </label>
            </div>
            <div className="flex flex-col lg:w-[45%] sm:w-full gap-2">
              <label className="lg:text-2xl sm:text-md font-jost text-gray-500">
                Preferred Start Date:
              </label>
              <input
                type="date"
                name="preferredStartDate"
                className="rounded border border-gray-300 text-xl font-jost"
                value={formData.preferredStartDate}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="flex flex-col gap-2 sm:mt-5">
            <label className="lg:text-2xl sm:text-md font-jost text-gray-500">
              Description of Specific Needs:
            </label>
            <textarea
              name="specificNeeds"
              className="w-full lg:h-56 sm:h-32 rounded border border-gray-300"
              value={formData.specificNeeds}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="flex flex-col gap-2 mt-4">
            <label className="lg:text-2xl sm:text-md font-jost rounded text-gray-500">
              Additional Notes/Comments:
            </label>
            <textarea
              name="additionalNotes"
              className="border-2 border-gray-300 rounded lg:h-56 sm:h-32"
              value={formData.additionalNotes}
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
      </div>

      <button
        className="px-8 py-2 font-jost lg:text-xl sm:text-sm sm:mt-5 backGroundCustom text-white rounded"
        type="submit"
      >
        Submit
      </button>
    </form>
  );
};

export default ServiceForm;
